export const isMac = typeof window !== "undefined" ? navigator.userAgent.indexOf("Mac") != -1 : false;
